import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const emailMessages = defineMessages({
  required: {
    id: 'confirmation.email.required',
    defaultMessage: 'The email is required'
  },
  max: {
    id: 'confirmation.email.max',
    defaultMessage: 'The email can be up to 255 characters'
  },
  format: {
    id: 'confirmation.email.format',
    defaultMessage: 'The format is incorrect'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    emails: yup.array().min(1, intl.formatMessage(emailMessages.required)),
    email: yup.string().max(255, intl.formatMessage(emailMessages.max)).email(intl.formatMessage(emailMessages.format))
  })
}
